import { createRequest, RequestConfig } from 'app/common/api';

import { TEventsConstraints } from '../core/events-constraints';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/get_journal_records',
};

export const getEventsRequest = (constraints?: TEventsConstraints) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(constraints),
  });
